import { Space, Tooltip, Typography } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import moment from "moment";
import React, { useMemo, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { autoOasisLogin, speedMateLogin } from "../../../apis/Login/apis";
import {
  bulkCompleteService,
  completeService,
  sbulkCompleteService,
  scompleteService,
} from "../../../apis/Order";
import {
  fetchReservations,
  sfetchAllReservations,
  sfetchReservations,
} from "../../../apis/Reservation/apis";
import { ReservationListSearchQuery } from "../../../apis/Reservation/apis/types";
import Button from "../../../components/atoms/Button";
import { TableFilterFormElementType } from "../../../components/molecures/TableFilter/enums";
import { TableFilterForm } from "../../../components/molecures/TableFilter/interfaces";
import { InterfaceNotice } from "../../../components/organisms/Icon";
import { IconForm } from "../../../components/organisms/Icon/index.styled";
import { sendSignOut } from "../../../components/organisms/Layout/apis";
import { ReservationExpendedInfo } from "../../../components/organisms/Reservation/Expended";
import {
  ProductStatus,
  ProductStatusTag,
} from "../../../components/organisms/Reservation/Expended/Products/ProductStatus";
import { JobTaskForm } from "../../../components/organisms/Reservation/JobTask";
import { ReservationNoticeInfo } from "../../../components/organisms/Reservation/NoticeInfo";
import { RepairStatusTag } from "../../../components/organisms/Reservation/Tags/RepairStatus";
import { ConfirmEm } from "../../../components/organisms/Reservation/index.styled";
import { getModelAllYr } from "../../../components/organisms/Reservation/utils/modelYear";
import useModals from "../../../hooks/useModals";
import useShop from "../../../hooks/useShop";
import useUser from "../../../hooks/useUsers";
import { RepairShop } from "../../../model/RepairShop";
import { Reservation } from "../../../model/Reservation";
import { ReservationOrderItemInfo } from "../../../model/Reservation/OrderItem";
import { Delivery } from "../../../model/ReservationDetail";
import { HttpError } from "../../../network/types";
import {
  PATH,
  autoOasisCodeString,
  speedMateCodeString,
} from "../../../routes/constants/path";
import sharedConstants from "../../../shared/constants";
import { PartnerBosRepairStatuses } from "../../../shared/enums";
import { repairStatusArray } from "../../../shared/options";
import { alertError, alertSuccess } from "../../../shared/utils";
import { getDecodeToken } from "../../../shared/utils/Token";
import color from "../../../theme/color";
import ReservationPaginationTable from "../components/ReservationPaginationTable";

/**
 * 스피드메이트 및 오토오아시스용
 * @TODO 필요시 분리 수정하기
 * @returns
 */
const SpeedMateReservationManager: React.FC = () => {
  const { getAdminInfo, getUserID } = useUser();
  const { openConfirmModal, openAlertModal, closeModal, openModal } =
    useModals();
  const nav = useNavigate();
  const location = useLocation();
  const { shop } = useShop();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const specialCode: string | undefined =
    location.search?.includes(speedMateCodeString) ||
    location.search?.includes(autoOasisCodeString)
      ? location
        ? location?.search
            ?.split("&")
            ?.find(
              (text) =>
                text.includes(speedMateCodeString) ||
                text.includes(autoOasisCodeString)
            )
            ?.split("=")[1]
        : undefined
      : undefined;
  const { signIn, signOut } = useUser();
  const ref = useRef<any>();

  const { mutateAsync: completeServiceMutateAsync } = useMutation(
    specialCode ? scompleteService : completeService,
    {
      onSuccess: () => {
        alertSuccess("작업완료되었습니다.");

        ref.current.reload();
        closeModal();
      },
      onError: (err: HttpError) => {
        closeModal();
        if ((err.status === 401 || err.status === 403) && specialCode) {
          signOut();
          signOutMutation.mutate();
        }
        if (
          err.notTranslate ===
          "CANNOT_COMPLETED_SERVICE_UNTIL_ALL_COMPLETED_GOODS_ISSUE"
        )
          openAlertModal({
            contents: (
              <>
                주문상품이 모두 <ConfirmEm>&lsquo;출고완료&rsquo;</ConfirmEm>
                상태가 되어야 <ConfirmEm>&lsquo;작업 완료&lsquo;</ConfirmEm>가
                가능합니다
              </>
            ),
            title: "작업완료 불가",
            okText: "닫기",
          });
        else alertError(err.message);
      },
    }
  );

  const { mutate: bulkCompleteServiceMutate } = useMutation(
    specialCode ? sbulkCompleteService : bulkCompleteService,
    {
      onSuccess: (data) => {
        alertSuccess("작업완료되었습니다.");

        openModal(
          <JobTaskForm
            taskId={data.taskId}
            onClose={() => {
              ref.current.reload();
              closeModal();
            }}
            isSpecial={!!specialCode}
          />
        );
      },
      onError: (err: HttpError) => {
        closeModal();
        if ((err.status === 401 || err.status === 403) && specialCode) {
          signOut();
          signOutMutation.mutate();
        }
        if (
          err.notTranslate ===
          "CANNOT_COMPLETED_SERVICE_UNTIL_ALL_COMPLETED_GOODS_ISSUE"
        )
          openAlertModal({
            contents: (
              <>
                주문상품이 모두 <ConfirmEm>&lsquo;출고완료&rsquo;</ConfirmEm>
                상태가 되어야 <ConfirmEm>&lsquo;작업 완료&lsquo;</ConfirmEm>가
                가능합니다
              </>
            ),
            title: "작업완료 불가",
            okText: "닫기",
          });
        else alertError(err.message);
      },
    }
  );

  const signOutMutation = useMutation(sendSignOut, {
    onSuccess: () => {
      if (specialCode) {
        if (location.search?.includes(speedMateCodeString))
          singInSpeedMateMutation.mutate({ repairShopCode: specialCode });
        if (location.search?.includes(autoOasisCodeString))
          singInAutoOasisMutation.mutate({ autooasisCode: `${specialCode}` });
      }
    },
    onError: () => {
      if (specialCode) {
        if (location.search?.includes(speedMateCodeString))
          singInSpeedMateMutation.mutate({ repairShopCode: specialCode });
        if (location.search?.includes(autoOasisCodeString))
          singInAutoOasisMutation.mutate({ autooasisCode: `${specialCode}` });
      }
    },
  });

  const filterForms: TableFilterForm[] = [
    {
      type: TableFilterFormElementType.Input,
      label: "주문번호",
      placeholder: "주문번호를 입력해주세요",
      key: "orderNo",
    },
    {
      type: TableFilterFormElementType.Select,
      label: "예약상태",
      placeholder: "예약상태를 선택하세요",
      key: "repairStatus",
      options: repairStatusArray,
    },
    {
      type: TableFilterFormElementType.DateRangePicker,
      label: "예약일",
      key: "reservedAt",
      dateRangeKeys: ["reservedAtFrom", "reservedAtTo"],
    },
    {
      type: TableFilterFormElementType.Input,
      label: "고객명",
      placeholder: "고객명을 입력해주세요",
      key: "consumerName",
    },
    {
      type: TableFilterFormElementType.Input,
      label: "휴대폰번호",
      placeholder: "'-'없이 숫자만 입력해주세요",
      key: "consumerPhone",
    },
    {
      type: TableFilterFormElementType.Input,
      label: "차량번호",
      placeholder: "차량번호를 입력해주세요",
      key: "vehicleNo",
    },
    {
      type: TableFilterFormElementType.Select,
      label: "방문방법",
      placeholder: "방문방법을 선택해주세요",
      key: "isValet",
      options: [
        { label: "고객방문", value: false },
        { label: "발렛장착", value: true },
      ],
    },
    {
      type: TableFilterFormElementType.Select,
      label: "상품분류",
      placeholder: "상품분류를 선택해주세요",
      key: "productType",
      options: Object.entries(ProductStatus)
        .filter(([k, v]) => k !== "ETC")
        .map(([k, v]) => ({ label: v, value: k })),
    },
    {
      type: TableFilterFormElementType.Input,
      label: "운송장번호",
      key: "trackingNo",
      placeholder: "운송장번호를 입력해주세요",
    },
  ];

  const masterFilterForms: TableFilterForm[] = [
    {
      type: TableFilterFormElementType.Input,
      label: "주문번호",
      placeholder: "주문번호를 입력해주세요",
      key: "orderNo",
    },
    {
      type: TableFilterFormElementType.Select,
      label: "예약상태",
      placeholder: "예약상태를 선택하세요",
      key: "repairStatus",
      options: repairStatusArray,
    },
    // {
    //   type: TableFilterFormElementType.DateRangePicker,
    //   label: "주문일",
    //   key: "orderedAt",
    //   dateRangeKeys: ["orderedAtFrom", "orderedAtTo"],
    // },
    {
      type: TableFilterFormElementType.DateRangePicker,
      label: "예약일",
      key: "reservedAt",
      dateRangeKeys: ["reservedAtFrom", "reservedAtTo"],
    },
    {
      type: TableFilterFormElementType.Input,
      label: "고객명",
      placeholder: "고객명을 입력해주세요",
      key: "consumerName",
    },
    {
      type: TableFilterFormElementType.Input,
      label: "휴대폰번호",
      placeholder: "'-'없이 숫자만 입력해주세요",
      key: "consumerPhone",
    },
    {
      type: TableFilterFormElementType.Input,
      label: "차량번호",
      placeholder: "차량번호를 입력해주세요",
      key: "vehicleNo",
    },
    {
      type: TableFilterFormElementType.Select,
      label: "방문방법",
      placeholder: "방문방법을 선택해주세요",
      key: "isValet",
      options: [
        { label: "고객방문", value: false },
        { label: "발렛장착", value: true },
      ],
    },
    {
      type: TableFilterFormElementType.Select,
      label: "상품분류",
      placeholder: "상품분류를 선택해주세요",
      key: "productType",
      options: Object.entries(ProductStatus)
        .filter(([k, v]) => k !== "ETC")
        .map(([k, v]) => ({ label: v, value: k })),
    },
    {
      type: TableFilterFormElementType.Input,
      label: "매장명",
      key: "displayName",
      placeholder: "매장명을 입력해주세요",
    },
    {
      type: TableFilterFormElementType.Input,
      label: "운송장번호",
      key: "trackingNo",
      placeholder: "운송장번호를 입력해주세요",
    },
  ];

  /**
   * 상품 타입 추출
   * @param record
   * @returns
   */
  const uniqueProductType = (record: Reservation) => {
    const types = record.orderItems
      .filter((item) => item.productType !== "ETC")
      .map((item) => item.productType);

    const typeSet = new Set(types);
    const unique = Array.from(typeSet);

    return unique;
  };

  const masterColumns: ColumnsType<Reservation> = [
    {
      dataIndex: "repairNo",
      key: "repairNo",
      width: 200,
      title: "주문번호",
      align: "center",
      fixed: "left",
    },
    {
      dataIndex: "repairShop",
      width: 150,
      title: "매장코드",
      render: (value: RepairShop) => {
        return value ? value.repairShopCode || "-" : "-";
      },
    },
    {
      dataIndex: "repairShop",
      width: 200,
      title: "매장명",
      render: (value: RepairShop) => {
        return value ? value.displayName || "-" : "-";
      },
    },
    {
      dataIndex: "orderItems",
      width: 180,
      title: "상품분류",
      align: "left",
      render: (value, record) => {
        const badges = uniqueProductType(record);

        return (
          <div style={{ display: "inline-flex", gap: 8 }}>
            {badges
              ? badges.map((badge) => <ProductStatusTag value={badge} />)
              : "-"}
          </div>
        );
      },
    },
    {
      dataIndex: "reservedAt",
      width: 180,
      title: "예약일시",
      ellipsis: true,
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm") : "-",
    },
    {
      dataIndex: "order",
      title: "고객명",
      width: 112,
      render: (value) => {
        return value?.consumerName || "-";
      },
    },
    {
      dataIndex: "customerVehicleNo",
      title: "차량번호",
      width: 112,
      align: "center",
    },
    {
      dataIndex: "vehicle",
      key: "vehicleModel",
      title: "차종",
      width: 200,
      align: "center",
      render: (value) =>
        value?.vehicleDetailGroupName || value?.displayVehicleModel || "-",
    },
    {
      dataIndex: "vehicle",
      key: "modelYear",
      title: "모델년도",
      width: 120,
      align: "center",
      render: (value) => getModelAllYr(value) || "-",
    },
    {
      dataIndex: "valet",
      key: "valet",
      title: "방문방법",
      width: 100,
      align: "center",
      render: (value) => (value?.valetNo ? "발렛장착" : "고객방문"),
    },
    {
      dataIndex: "goodsIssue",
      key: "goodsIssue",
      title: "운송장번호",
      width: 120,
      align: "center",
      render: (value) => {
        /**
         * 환불상품 필터링하고 보여주기
         */
        const returns =
          value?.goodsIssueItems?.[0]?.deliveryList
            ?.filter((item: Delivery) => item.deliveryType === "RETURN")
            .map((item: Delivery) => item.deliveryNo) || [];

        // 회송된 상품 제외 하고 보여주기
        return value?.goodsIssueItems?.[0]?.deliveryList
          ?.filter(
            (item: Delivery) =>
              item.deliveryType === "DELIVERY" &&
              !returns.includes(item.deliveryNo)
          )
          .map((item: Delivery) => item.trackingNo || "-")
          .join(", ");
      },
    },
    {
      dataIndex: "repairStatus",
      key: "repairStatus",
      title: (
        <Tooltip
          placement="bottomRight"
          color={color.gray12}
          title={<ReservationNoticeInfo />}
          showArrow={false}
          overlayStyle={{
            minWidth: 420,
          }}
          overlayInnerStyle={{
            padding: 16,
          }}
        >
          <Space size={4} align="center">
            <Typography.Text color={color.gray4}>예약상태</Typography.Text>
            <IconForm
              component={InterfaceNotice}
              color={color.gray5}
              style={{ fontSize: 15 }}
            />
          </Space>
        </Tooltip>
      ),
      width: 120,
      align: "center",
      render: (value) => <RepairStatusTag value={value} size="medium" />,
    },
    {
      dataIndex: "button",
      key: "button",
      title: "",
      width: 98,
      align: "center",
      fixed: "right",
      render: (_, record) => {
        return record?.repairStatus ===
          PartnerBosRepairStatuses.RESERVATION_COMPLETED ? (
          <Button
            ghost
            type="primary"
            disabled={moment().isBefore(moment(record.reservedAt))}
            onClick={(e) => {
              e.stopPropagation();
              openConfirmModal({
                contents: "해당 항목을 '작업완료'하시겠습니까?",
                title: "작업완료",
                onOk: () => {
                  completeServiceMutateAsync(record.repairNo);
                },
                okText: "작업완료",
              });
            }}
          >
            작업완료
          </Button>
        ) : (
          "-"
        );
      },
    },
  ];

  const columns: ColumnsType<Reservation> = [
    {
      dataIndex: "repairNo",
      key: "repairNo",
      width: 200,
      title: "주문번호",
      align: "center",
      fixed: "left",
    },
    {
      dataIndex: "orderItems",
      width: 180,
      title: "상품분류",
      align: "left",
      render: (value, record) => {
        const badges = uniqueProductType(record);

        return (
          <div style={{ display: "inline-flex", gap: 8 }}>
            {badges
              ? badges.map((badge) => <ProductStatusTag value={badge} />)
              : "-"}
          </div>
        );
      },
    },
    {
      dataIndex: "reservedAt",
      width: 180,
      title: "예약일시",
      align: "center",
      render: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm") : "-",
    },
    {
      dataIndex: "order",
      title: "고객명",
      width: 112,
      align: "center",
      render: (value) => {
        return value?.consumerName || "-";
      },
    },
    {
      dataIndex: "customerVehicleNo",
      title: "차량번호",
      width: 112,
      align: "center",
    },
    {
      dataIndex: "vehicle",
      key: "vehicleModel",
      title: "차종",
      width: 200,
      align: "center",
      render: (value) =>
        value?.vehicleDetailGroupName || value?.displayVehicleModel || "-",
    },
    {
      dataIndex: "vehicle",
      key: "modelYear",
      title: "모델년도",
      width: 120,
      align: "center",
      render: (value) => getModelAllYr(value) || "-",
    },
    {
      dataIndex: "valet",
      title: "방문방법",
      width: 100,
      align: "center",
      render: (value) => (value?.valetNo ? "발렛장착" : "고객방문"),
    },
    {
      dataIndex: "goodsIssue",
      key: "goodsIssue",
      title: "운송장번호",
      width: 120,
      align: "center",
      render: (value) => {
        /**
         * 환불상품 필터링하고 보여주기
         */
        const returns =
          value?.goodsIssueItems?.[0]?.deliveryList
            ?.filter((item: Delivery) => item.deliveryType === "RETURN")
            .map((item: Delivery) => item.deliveryNo) || [];

        // 회송된 상품 제외 하고 보여주기
        return value?.goodsIssueItems?.[0]?.deliveryList
          ?.filter(
            (item: Delivery) =>
              item.deliveryType === "DELIVERY" &&
              !returns.includes(item.deliveryNo)
          )
          .map((item: Delivery) => item.trackingNo || "-")
          .join(", ");
      },
    },
    {
      dataIndex: "repairStatus",
      title: (
        <Tooltip
          placement="bottomRight"
          color={color.gray12}
          title={<ReservationNoticeInfo />}
          showArrow={false}
          overlayStyle={{
            minWidth: 420,
          }}
          overlayInnerStyle={{
            padding: 16,
          }}
        >
          <Space size={4} align="center">
            <Typography.Text color={color.gray4}>예약상태</Typography.Text>
            <IconForm
              component={InterfaceNotice}
              color={color.gray5}
              style={{ fontSize: 15 }}
            />
          </Space>
        </Tooltip>
      ),
      width: 98,
      align: "center",
      render: (value) => <RepairStatusTag value={value} size="medium" />,
    },
    Table.SELECTION_COLUMN,
    {
      dataIndex: "button",
      title: "",
      width: 98,
      align: "center",
      fixed: "right",
      render: (_, record) => {
        return record?.repairStatus ===
          PartnerBosRepairStatuses.RESERVATION_COMPLETED ? (
          <Button
            ghost
            disabled={moment().isBefore(moment(record.reservedAt))}
            onClick={(e) => {
              e.stopPropagation();
              openConfirmModal({
                contents: "해당 항목을 '작업완료'하시겠습니까?",
                title: "작업완료",
                onOk: () => {
                  completeServiceMutateAsync(record.repairNo);
                },
                okText: "작업완료",
              });
            }}
          >
            작업완료
          </Button>
        ) : (
          "-"
        );
      },
    },
  ];

  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isClick, setClick] = useState(false);
  const [isDragging, setDragging] = useState(false);
  const fetchAction = async (
    page: number,
    pageSize: number,
    filterValues: ReservationListSearchQuery
  ) => {
    try {
      if (specialCode) {
        if (sharedConstants.masterCodes.includes(specialCode)) {
          const { rows, count } = await sfetchAllReservations({
            page,
            pageSize,
            ...filterValues,
            repairShopId: getAdminInfo()?.id || 0,
            specialCode,
          });
          setRows(rows);
          setTotalCount(count);
        } else {
          const { rows, count } = await sfetchReservations({
            page,
            pageSize,
            ...filterValues,
            repairShopId: getAdminInfo()?.id || 0,
            specialCode,
          });
          setRows(rows);
          setTotalCount(count);
        }
      } else {
        const { rows, count } = await fetchReservations({
          page,
          pageSize,
          ...filterValues,
          repairShopId: getAdminInfo()?.id || 0,
          specialCode,
        });
        setRows(rows);
        setTotalCount(count);
      }
    } catch (e) {
      setRows([]);
      setTotalCount(0);
      const error = e as HttpError;

      if ((error.status === 401 || error.status === 403) && specialCode) {
        signOut();
        if (specialCode) {
          if (location.search?.includes(speedMateCodeString))
            singInSpeedMateMutation.mutate({
              repairShopCode: specialCode.toString(),
            });
          if (location.search?.includes(autoOasisCodeString))
            singInAutoOasisMutation.mutate({
              autooasisCode: `${specialCode}`,
            });
        }
      }
      if (error.status !== 404) alertError(error.message);
    }
  };

  const singInSpeedMateMutation = useMutation(speedMateLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
      }
      if (rows.length === 0)
        window.setTimeout(() => {
          window.location.reload();
        }, 1000);
    },
    onError: () => {},
  });
  const singInAutoOasisMutation = useMutation(autoOasisLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
      }
      if (rows.length === 0)
        window.setTimeout(() => {
          window.location.reload();
        }, 1000);
    },
    onError: () => {},
  });
  const handleClickTableRow = (record: any) => {
    if (!isDragging)
      if (!specialCode)
        nav(`/reservations/${record?.repairNo}${location.search}`);
      else if (location.search?.includes(speedMateCodeString)) {
        nav(
          `${`${PATH.SPEED_MATE_RESERVATION}/${record?.repairNo}`}${
            location.search
          }`
        );
      } else if (location.search?.includes(autoOasisCodeString))
        nav(
          `${`${PATH.AUTO_OASIS_RESERVATION}/${record?.repairNo}`}${
            location.search
          }`
        );
    setClick(false);
    setDragging(false);
  };
  const master = useMemo(() => {
    const info = getDecodeToken();

    return info?.isMaster && +shop === getUserID();
  }, [shop]);

  /**
   * 일괄 작업완료 요청
   */
  const handleAllCompleted = () => {
    if (selectedRowKeys.length) {
      openConfirmModal({
        title: "일괄 작업완료 요청",
        contents: `선택 된 ${selectedRowKeys.length}개 주문에 대하여 일괄 작업완료를 진행하시겠습니까?`,
        onOk: () => {
          bulkCompleteServiceMutate(selectedRowKeys as string[]);
        },
      });
    } else {
      openAlertModal({
        title: "선택된 주문 없음",
        contents: "선택된 주문이 없습니다.",
      });
    }
  };

  return (
    <>
      {/* <ReservationSpecialListForm /> */}
      <ReservationPaginationTable
        // headerElement={
        //   <div style={{ marginBottom: 16 }}>
        //     <ReservationNoticeInfo />
        //   </div>
        // }
        headerButtonList={[
          {
            type: "primary",
            label: "일괄 작업완료",
            onClick: handleAllCompleted,
            disabled: selectedRowKeys.length < 1,
          },
        ]}
        columns={
          (specialCode && sharedConstants.masterCodes.includes(specialCode)) ||
          master
            ? masterColumns
            : columns
        }
        pageTitle="예약현황"
        smallPageTitle="예약관리"
        headerTitle="예약 리스트"
        dataSource={rows}
        autooasisCode={
          location.search?.includes(autoOasisCodeString)
            ? specialCode
            : undefined
        }
        speedMateCode={
          location.search?.includes(speedMateCodeString)
            ? specialCode
            : undefined
        }
        onRow={(record) => {
          return {
            onMouseDown: () => {
              setClick(true);
            },
            onMouseMove: () => {
              if (isClick) setDragging(true);
            },
            onClick: () => {
              handleClickTableRow(record);
            },
          };
        }}
        rowKey="repairNo"
        ref={ref}
        totalCount={totalCount}
        fetchAction={fetchAction}
        filterForms={
          (specialCode && sharedConstants.masterCodes.includes(specialCode)) ||
          master
            ? masterFilterForms
            : filterForms
        }
        verticalAlign="center"
        expandable={{
          expandedRowRender: (record) => (
            <ReservationExpendedInfo record={record} />
          ),
          rowExpandable: (record) =>
            record.orderItems &&
            record.orderItems.length > 0 &&
            record.orderItems.filter(
              (item: ReservationOrderItemInfo) => item.productType
            ).length > 0,
        }}
        rowSelection={{
          fixed: true,
          getCheckboxProps: (record) => ({
            disabled:
              record?.repairStatus !==
                PartnerBosRepairStatuses.RESERVATION_COMPLETED ||
              moment().isBefore(moment(record.reservedAt)),
            name: record.reservedAt,
          }),
          onChange: (selectedRowKeys) => {
            setSelectedRowKeys([...selectedRowKeys]);
          },
        }}
      />
    </>
  );
};
export default SpeedMateReservationManager;
